import { createCustomEnum } from "./customEnum";

const StatusHierarchyTypes = createCustomEnum({
	Active: {
		value: 0,
		name: "active",
		displayName: "Active",
	},
	Inactive: {
		value: 1,
		name: "inactive",
		displayName: "Inactive",
	},
});

export default StatusHierarchyTypes;
